export const GA_MEASUREMENT_ID = "UA-108144156-1";